import { combineReducers } from 'redux';
import { responsiveStateReducer } from 'redux-responsive';
import responsiveDrawer from './responsiveDrawer';

const rootReducer = combineReducers({
    browser: responsiveStateReducer,
    responsiveDrawer: responsiveDrawer
})

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js